<template>
    <div 
        class="a-container"
    >
        <div
            class="popup"
        >
            <div class="title">
                <span class="title-text">Acceso no disponible a Facturación Electrónica</span>
            </div>
            <div class="description">
                <span class="description-text">
                    Tu empresa aún no está vinculada con VeriFactu, por lo que el módulo de Facturación Electrónica no se encuentra disponible.</br></br>

                    Para habilitarlo, configura tu empresa siguiendo estos pasos: </br></br>

                    <ol>
                        <li>Ingresa a la ventana <strong>Emisor de Facturas</strong> en tu empresa.</li>
                        <li>Haz clic en <strong>Editar Emisor</strong> y completa los datos requeridos o sube la información necesaria.</li>
                        <li>Presiona <strong>Guardar</strong>.</li>
                        <li>Se abrirá una nueva ventana llamada <strong>Configuración de RRSIF</strong>. Allí encontrarás 4 casillas (<em>checkbox</em>), y al menos una debe estar seleccionada para activar el módulo.</li>
                    </ol></br>
                    
                    Una vez completados estos pasos, el módulo de Facturación Electrónica estará disponible.
                </span>
            </div>
            <div class="a-center">
                <button
                    class="a-button"
                    v-on:click="openEditCompanyDB"
                >
                    <span class="a-button-text">Ir a Empresa</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'AccessDeniedToFacturaEPopup',
    components: {

    },

    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
        },
    },

    data() {
        
    },

    mounted(){
        console.log("sds", this.companydb_id)
    },

    methods:{
        openEditCompanyDB() {
            let routeData = this.$router.resolve({name: 'connector-update', params: { 'id': this.companydb_id }});
            window.open(routeData.href, '_blank');
        },
    }
}
</script>

<style scoped>

.a-container {
    position: fixed; 
    left: 0; 
    top: 0; 
    width: 100%; 
    height: 100%; 
    background-color: rgba(0, 0 , 0, 0.5);
    z-index: 9999; 
    display: flex; 
    justify-content: center; 
    align-items: center;
}

.popup{
    width: 70%; 
    height: 70%;
    background-color: white; 
    border-radius: 30px;
}

.title{
    border-bottom: 0.2px solid gray; 
    padding: 20px 40px;
}

.title-text {
    color: var(--v-primary-base);
    font-size: 20px;
    font-weight: 700;
}

.description{
    padding: 20px 40px;
}

.description-text {
    font-size: 16px;
    font-weight: 500;
    color: #565656;
}

.a-button{
    padding: 10px 40px; 
    background-color: #565656; 
    border-radius: 8px;
}

.a-button-text{
    font-weight: 500; 
    font-size: 14px; 
    color: white
}

.a-center{
    display: flex; 
    align-items: center; 
    justify-content: center;
}

</style>